import { App } from 'vue'
import config from './sensorsdata/qtconfig'

type QTOptions = {
  sdk: string
  appKey: string
  aplus_host: string
  platformName: string
  show_log: boolean
}

class QT {
  options
  constructor() {}
  init(options: QTOptions) {
    this.options = options || {}
    ;(function (w, d, s, q) {
      w[q] = w[q] || []
      const f: any = d.getElementsByTagName(s)[0],
        j: any = d.createElement(s)
      j.async = true
      j.id = 'beacon-aplus'
      j.src = options.sdk // 初始化sdk
      j.onload = () => {
        console.log('sdk init success')
      }
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'aplus_queue')
    //集成应用的appKey
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['appKey', options.appKey],
    })
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-rhost-v', options.aplus_host],
    })
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-autotrack-enabled', true],
    })
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: [
        'aplus-auto-clk-userfn',
        function (e) {
          if (e.className.indexOf('autotrack_clk_web') != -1) {
            let dataset = e.dataset
            let obj: any = {}
            obj.itemID = dataset.itemid
            obj.itemName = dataset.itemname
            obj.itemZoon = dataset.itemzoon
            obj.promotionInformation = dataset.promotioninformation
            obj.pageName = dataset.pagename
            return {
              userdata: obj,
            }
          }
        },
      ],
    })
    if (options.show_log) {
      window.aplus_queue.push({ action: 'aplus.setMetaInfo', arguments: ['DEBUG', true] })
    }
  }
  /**
   *  设置用户账号
   */
  setMetaInfo(user_id: string) {
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_user_id', user_id],
    })
  }
  /**
   *
   * @param params 设置用户属性
   */
  setUserProfile(params: Record<string, string>) {
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: ['$$_user_profile', 'OTHER', params],
    })
  }
  /**
   *
   * @param params 设置全局属性
   */
  setGlobalproperty(params: Record<string, string>) {
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo', //覆盖全局属性
      arguments: ['globalproperty', params],
    })
  }
  /**
   * 追加全局属性
   * @param params
   */
  appenGlobalproperty(params: Record<string, string>) {
    console.log('--appenGlobalproperty---', params)
    window.aplus_queue.push({
      action: 'aplus.appendMetaInfo',
      arguments: ['globalproperty', params],
    })
  }

  /**
   *
   * @param event CLK 点击 | EXP 曝光 | OTHER 其他事件
   * @param params
   */
  track(event: { type?: string; eventName: string }, params: Record<string, string | Number>) {
    const { type, eventName } = event
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [eventName, type || 'CLK', params],
    })
  }
}

const qt = new QT()

const install = (app: App<Element>) => {
  let env = 'prod'
  if (import.meta.env.VITE_NODE_ENV !== 'production') {
    env = 'test'
  }
  const QTConfig: QTOptions = config[env]

  qt.init({
    sdk: QTConfig.sdk,
    appKey: QTConfig.appKey,
    aplus_host: QTConfig.aplus_host,
    platformName: QTConfig.platformName,
    show_log: import.meta.env.VITE_NODE_ENV !== 'production',
  })
  app.config.globalProperties.$qt = qt
}

export default {
  install,
  qt,
}
